import { render, staticRenderFns } from "./Reply.vue?vue&type=template&id=b9478988"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports